import React, { useEffect, useState } from "react";
import { ProductCategory } from "~/common/Store/models/ProductPage";
import { ProductBrand } from "./ProductDetailPageResult";
import { ButtonLink } from "@clarkinc/zest-design-system/ui";
import { Image } from "@wss/image";

interface Props {
  primaryBrand: ProductBrand;
  defaultCategory: ProductCategory;
}

const ProductDetailBrandSideSection = ({
  primaryBrand,
  defaultCategory,
}: Props) => {
  const [brandImageLink, setBrandImageLink] = useState<string>("");

  useEffect(() => {
    const imageLinkArr = primaryBrand.imageLink.split(".");
    const imageFormat = imageLinkArr[1];
    if (imageFormat === "svg") {
      setBrandImageLink(`/images/vendor/${primaryBrand.imageLink}`);
    } else {
      setBrandImageLink(`/images/vendor/medium/${primaryBrand.imageLink}`);
    }
  }, [primaryBrand.imageLink]);

  let brandCategoryName = primaryBrand.name ? primaryBrand.name : "";
  if (primaryBrand?.brandedPrimaryCategoryName) {
    brandCategoryName = primaryBrand.brandedPrimaryCategoryName;
  } else if (defaultCategory?.name) {
    brandCategoryName = brandCategoryName.concat(" ", defaultCategory.name);
  }

  return (
    <div
      className="flex gap-6 bg-white p-5 mt-1 border-solid border-gray-200 border-0 sm:gap-9 lt:flex-col lt:gap-4 lt:border-t lt:mt-0 lt:border"
      data-testid="brand-side-section"
    >
      <a
        href={primaryBrand.link}
        title={primaryBrand.name}
        className="lt:px-[10%]"
      >
        <Image
          src={brandImageLink}
          alt={`View All Products From ${primaryBrand.name}`}
          title={`View All Products From ${primaryBrand.name}`}
          width={300}
          height={150}
          data-testid="brand-link"
          className="box-border w-56 h-full p-2 border border-solid rounded border-gray-200 xm:w-full lt:border-0 lt:p-0"
        />
      </a>
      {defaultCategory && (
        <ButtonLink
          theme="wss"
          variant="plain"
          href={primaryBrand.categoryLinkWithVendor}
          title={primaryBrand.name}
          className="text-balance font-semibold leading-none text-base md:text-lg md:leading-none lt:text-center lt:text-sm lt:leading-4 lt:font-normal"
          data-testid="brand-category-link"
        >{`View all ${brandCategoryName}`}</ButtonLink>
      )}
    </div>
  );
};

export default ProductDetailBrandSideSection;
